import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { About } from './components/About';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Areas } from './components/Areas';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import FAQPage from './pages/FAQPage';
import GutterCleaningLeamingtonSpaPage from './pages/GutterCleaningLeamingtonSpaPage';

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Trust />
      <About />
      <Services />
      <Gallery />
      <Areas />
      <Reviews />
      <FAQ variant="preview" />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/gutter-cleaning-leamington-spa" element={<GutterCleaningLeamingtonSpaPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
